import { IconsProps } from '@/types/shared'
import React from 'react'

const MinusIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                fill="currentColor"
            >
                <path d="M200-440v-80h560v80H200Z" />
            </svg>
        </div>
    )
}

export default MinusIcons
